import { useEffect, useState } from "react";
import { fetchEfolderSummary } from "../../service/efolderUpload";

// How many central eFolder zips are waiting for a person, firm-wide (spec
// 9.2.7): review is shared work like mail, so the badge shows everyone's.
const useEfolderReviewCount = (enabled, refreshKey) => {
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (!enabled) return undefined;
    let live = true;
    fetchEfolderSummary()
      .then((body) => {
        if (live) setCount(Number(body?.firm?.needs_review) || 0);
      })
      .catch(() => {
        // A 404 (backend flag off) or outage: no badge, nothing else changes.
        if (live) setCount(0);
      });
    return () => {
      live = false;
    };
  }, [enabled, refreshKey]);
  return count;
};

export default useEfolderReviewCount;
